export default __webpack_public_path__ + "static/media/quote-left-solid.2cda652c.svg";